import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { reset_password_confirm_user_action } from "../../../redux/_actions";
import { showSuccessMessage } from "../../../_uiComponents/ShowMessageSnack";

function useResetPassword() {
  const [loading, setloading] = useState(false);
  const [formData, setformData] = useState({});
  const [formInputsError, setFormInputsError] = useState({});
  const [showPassword1, setshowPassword1] = useState(false);
  const [showPassword2, setshowPassword2] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  //initiate form data and set uid and token
  React.useEffect(() => {
    let data = {
      uid: "",
      token: "",
      new_password1: "",
      new_password2: "",
    }
    data.uid= params?.uid;
    data.token = params?.token;
    setformData(data);
  }, [params]);

  //submit password button
  const onResetPasswordClick = async () => {
    setloading(true);
    if (validateForm()) {
      const res = await dispatch(reset_password_confirm_user_action(formData));
      if(res){
        navigate('/sign-in')
      }
      
      setFormInputsError({})
    }
    setloading(false);
  };

  // show/hide passwords
  const onShowPasswordClick = (key) => {
    switch (key) {
      case "new_password1":
        setshowPassword1(!showPassword1);
        break;
      case "new_password2":
        setshowPassword2(!showPassword2);
        break;
      default:
        return;
    }
  };

  //set passwords on input change
  const onInputChange = (value, key) => {
    let data = formData;
    data[key] = value;
    setformData(data);
  };

  //validate form
  const validateForm = () => {
    let form_errors = {};

    // validate passwords
    if (formData.new_password1.length === 0) {
      form_errors = {
        new_password1: "Field cannot be empty",
      };
      setFormInputsError(form_errors);
      return false;
    }
    if (formData.new_password2.length === 0) {
      form_errors = {
        new_password2: "Field can not be empty",
      };
      setFormInputsError(form_errors);
      return false;
    }
    if (formData.new_password2 !== formData.new_password1) {
      form_errors = {
        new_password2: "Both passwords do not match",
      };
      setFormInputsError(form_errors);
      return false;
    }
    return true;
  };

  //go back button
  const onBackClick = () => {
    navigate(-1);
  };

  return {
    loading,
    showPassword1,
    showPassword2,
    formInputsError,

    onShowPasswordClick,
    onResetPasswordClick,
    onInputChange,
    onBackClick,
  };
}

export default useResetPassword;
